export default class ElementFilterForm {
  constructor(form, input, element_filter) {
    this.form = form;
    this.input = input;
    this.element_filter = element_filter;

    this.form.on("submit", false); // Disable form submission
    this.input.on("input", this.inputChanged.bind(this));
    this.inputChanged(); // Initial values on page load
  }

  inputChanged() {
    this.element_filter.filter(this.input.val());
  }
}
